import { Injectable } from '@angular/core';

@Injectable()
export abstract class ShippingWidgetNavigationService {
  /**
   * Opens the cxc shipments detail page via the provided tracking number.
   * @param trackingNumber The tracking number to open the transport detail page for.
   * @param arvatoDeliveryNumber The Arvato delivery number to open the transport detail page for.
   * @returns A promise that resolves when the navigation is complete.
   */
  public abstract openViaTrackingNumber(trackingNumber: string, arvatoDeliveryNumber?: string): Promise<void>;

  /**
   * Checks if the module is configured and if the user has the necessary permissions to open it.
   * @returns A boolean indicating whether the module can be opened.
   */
  public abstract mayOpenModule(trackingNumber: string, arvatoDeliveryNumber?: string): Promise<boolean>;
}
